import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { TAAConstants } from "../../../../views/constants/taa-constants";
import { AppService } from "../../../../views/services/app.service";
import { CommonService } from "../../../../views/services/common.service";
import { HeaderService } from "../../../../views/services/header.service";
import { User } from "../../../../views/services/user.model";
import { ReviewData } from "../../../../views/shared/models/review-data";
import { InternalLoggerService } from "../../accmgr/services/internal-audit-logger.service";
import { PaperStepperComponent } from "../process-paper-request/stepper/paper-stepper.component";
import { AccSupportPlanService } from "../service/accsupportplan.service";
import { PaperReqSubmitService } from "../service/paperreqsubmit.service";
import { PaperReqTestInfoService } from "../service/paperreqtestinfo.service";
import { PersonRequestService } from "./../../accmgr/services/person-request-service";

@Component({
  selector: "app-paperreqsubmit",
  templateUrl: "./paperreqsubmit.component.html",
  styleUrls: ["./paperreqsubmit.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class PaperReqSubmitComponent implements OnInit, OnDestroy {
  public selectedOrg: any;
  public successMessage: boolean;
  public errorMessage: boolean;
  public supReason: boolean = false;
  public disReason: boolean = false;
  public containsSupport: boolean = false;
  public containsAcc: boolean = false;
  public noOfErrors: number;
  public userProfile: User;
  frmTestingInfo: FormGroup;
  formSubmitted = false;
  Name: string;
  public testOptions: any = [];
  public testDates: any = [];
  public displayMiddle: boolean = false;
  public disPlan: boolean = false;
  public isPub: boolean = false;
  public testFlag: boolean = false;
  public testDateFlag: boolean = false;
  public showEditButtons: boolean;
  public showComments: boolean = false;
  public isLoading: boolean = false;
  public showCancelText: boolean = false;
  public showTerms: boolean = false;
  public showPrint: boolean = false;
  public inReviewMsg: boolean;
  public checkBox: boolean = false;
  public showCheckBoxError: boolean = false;
  public dynamicText: any;
  public confiramtionText: string;
  public signedReleaseText: any;
  public cancelText: any;
  public termsAndCondsText: any;
  public currentRecord: any;
  public personTestId: any;
  public testDateId: any;
  public testId: any;
  public reqAccommFl: any;
  public reqSupportFl: any;
  public reqStatusCdId: any;
  public reqStateTx: any;
  public personId: any;
  public requestId: any;
  public stateStudentId: string;
  public diagId: any;
  public planName: string;
  public planId: any;
  public personPlanLength: string;
  public displayPlanName: boolean = false;
  public personPlanId: any;
  public recvEllSupport: string;
  public supDisplay: string;
  public lengthDisplay: string;
  public accommCatId: string;
  public accommCatName: string;
  public accommName: string;
  public studentDetails: any;
  public personName: string;
  public reqAccoms: any;
  public documentList: any;
  public commentList: any;
  public commentTitle: string;
  public statusCd: string;
  public submitStatusCd: any;
  public incStatusCd: any;
  public pendStatusCd: any;
  public lockedFl: any;
  public emailSubject: string;
  public sender: string;
  public toSend: any;
  public saveAccomsList = [];
  public commentText: string = "";
  public commentTextError: boolean = false;
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public auditLogComponent: string = "";
  reviewData: ReviewData = {};
  public date: any;
  public showInvalidDataErr: boolean = false;

  public autoApprovalRequestObj = {
    disabilities: [],
    documents: [],
    planLength: "",
    accomsList: [],
    personId: "",
    requestId: ""
  };

  private subscriptions: Array<Subscription> = [];
  constructor(
    private appService: AppService,
    private headerService: HeaderService,
    public stepper: PaperStepperComponent,
    public requestSubmitService: PaperReqSubmitService,
    public planService: AccSupportPlanService,
    public commonService: CommonService,
    public personRequestService: PersonRequestService,
    public testService: PaperReqTestInfoService,
    private router: Router,
    public taaConstants: TAAConstants,
    private _loggerService: InternalLoggerService,
    public fb: FormBuilder
  ) {}

  ngOnInit() {
    sessionStorage.setItem("docSubmitted", "");
    this.selectedOrg = this.headerService.getselectedOrgDetails();
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    this.isLoading = true;
    this.reviewData.disabilityCategory = [];
    this.reviewData.documentDisplayList = [];
    this.reviewData.commentList = [];
    this.reviewData.displayAccomsList = [];
    this.autoApprovalRequestObj.disabilities = [];
    this.autoApprovalRequestObj.documents = [];
    this.autoApprovalRequestObj.planLength = "";
    this.autoApprovalRequestObj.accomsList = [];
    Observable.forkJoin(
      this.commonService.getDynContent("SIGNED_RELEASE_TEXT"),
      this.commonService.getDynContent("REQUEST_CANCEL_TEXT"),
      this.commonService.getDynContent("REQUEST_TERMS_CONDITIONS"),
      this.commonService.getDynContent("REQUEST_REVIEWSUBMIT_COMMENT_DESC"),
      this.commonService.getDynContent("REQUEST_CONFIRMATION_TEXT")
    ).subscribe(
      ([
        signedReleaseText,
        cancelText,
        termsAndCondsText,
        commentTitle,
        confiramtionText
      ]) => {
        this.signedReleaseText = signedReleaseText;
        this.cancelText = cancelText;
        this.termsAndCondsText = termsAndCondsText;
        this.commentTitle = commentTitle;
        this.confiramtionText = confiramtionText;
        this.reviewData.confiramtionText = confiramtionText;
      }
    );
    this.appService.getUserProfile().then(user => (this.userProfile = user));
    this.personId = this.currentRecord.personId;
    this.requestId = this.currentRecord.requestId;
    this.successMessage = false;
    this.errorMessage = false;
    this.buildForm();
  }

  ngOnDestroy() {
    for (const o of this.subscriptions) {
      o.unsubscribe();
    }
  }

  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: this.auditLogCategory,
      COMPONENT_ID: "TAC_REQUEST_SUBMIT",
      MESSAGE_TX: this.auditStatusText,
      REFERENCE_ID: this.personId,
      SEVERITY_VAL: "",
      CREATED_BY_DS: this.userProfile.loggedInUser,
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      USER_DATA_VAL:
        "Examinee " +
        this.reviewData.firstNm +
        " " +
        this.reviewData.lastNm +
        " is associated with test administration " +
        this.reviewData.testDateName
    };
    this._loggerService.updateAuditLogger(loggerModel).subscribe(
      success => {},
      err => {
        console.log(err);
      }
    );
  }

  buildForm() {
    Observable.forkJoin([
      this.personRequestService.getPersonById(this.personId),
      this.personRequestService.getPersonNameById(this.personId),
      this.personRequestService.getPersonAddressById(this.personId),
      this.testService.getInternalRequests(this.requestId),
      this.personRequestService.getPersonDocumentById(this.personId),
      this.personRequestService.getPersonPlanById(this.personId),
      this.personRequestService.getPersonDisabilityById(this.personId),
      this.personRequestService.getReqAccomsById(this.requestId)
    ]).subscribe(
      ([
        person,
        personName,
        personAddress,
        request,
        personDocument,
        personPlan,
        personDisability,
        accommodation
      ]) => {
        this.reviewData.actId = person[0].ACT_ID;
        this.date = person[0].BIRTH_DT.split("T")[0];
        this.reviewData.dateOfBirth = moment(this.date, "YYYY-MM-DD").format(
          "MM/DD/YYYY"
        );
        this.reviewData.stateStudentId = person[0].STATE_SYSTEM_ID;
        this.reviewData.taaPin = person[0].ACCOMMS_PIN;
        this.reviewData.firstNm = personName[0].FIRST_NM;
        this.reviewData.middleNm = personName[0].MIDDLE_NM;
        this.reviewData.lastNm = personName[0].LAST_NM;
        this.reviewData.address1 = personAddress[0].STREET_1_AD;
        this.reviewData.address2 = personAddress[0].STREET_2_AD;
        this.reviewData.city = personAddress[0].CITY_NM;
        this.reviewData.state = personAddress[0].STATE_CD;
        this.reviewData.zip = personAddress[0].ZIP_POSTAL_CD;
        this.reviewData.country = personAddress[0].COUNTRY_CD;
        this.reqAccommFl = request[0].REQ_TYP_ACCOM_FL;
        this.reqSupportFl = request[0].REQ_TYP_ELL_SUPP_FL;
        this.testId = request[0].TEST_ID;
        this.testDateId = request[0].TEST_DATE_ID;
        this.reqStatusCdId = request[0].REQUEST_STATUS_CODE_ID;
        this.reqStateTx = request[0].REQUEST_STATE_TX;
        this.personPlanId = personPlan;
        this.diagId = personDisability;
        this.documentList = personDocument;
        this.reqAccoms = accommodation;
        this.reviewData.personName =
          this.reviewData.firstNm +
          " " +
          this.reviewData.middleNm +
          " " +
          this.reviewData.lastNm;
        this.studentDetails = {
          personId: this.personId,
          requestId: this.requestId,
          taaPin: this.reviewData.taaPin,
          personName: this.reviewData.personName
        };
        this.buildTest();
      }
    );

    if (this.reviewData.middleNm !== "") {
      this.displayMiddle = true;
    }

    // get and display disabilities. Sort the categories and also the disabilities themselves
    // this.disabilityService.getDisabilityCategoryById(this.diagId).subscribe((response) => {
    //   this.diagCatName = response[0].DISABILITY_ID;
    // });

    // Display the disability labels only if the request has REQ_TYP_ACCOM_FL from Request Reason
    if (this.reqAccommFl === "Y") {
      this.disReason = true;
    }
  }

  buildDisability() {
    for (let i = 0; i < this.diagId.length; i++) {
      let otherExists = false;
      if (this.diagId[i].OTHER_DS) {
        this.diagId[i].OTHER_DS = "OTHER : " + this.diagId[i].OTHER_DS;
      }
      if (!this.diagId[i].OTHER_DS) {
        otherExists = true;
      }
      const data: any = {};
      Observable.forkJoin(
        this.personRequestService.getDisabilitiesName(
          this.diagId[i].DISABILITY_ID
        )
      ).subscribe(([response]) => {
        if (response) {
          this.autoApprovalRequestObj.disabilities.push(
            response.body[0].DISABILITY_NM
          );
          if (!response.body[0].DISABILITY_NM.includes("ELL_")) {
            this.containsAcc = true;
          }
          Observable.forkJoin(
            this.personRequestService.getDisabilitiesCategoryName(
              response.body[0].DISABILITY_CATEGORY_ID
            )
          ).subscribe(([result]) => {
            data.DISABILITY_CATEGORY_NM = result.body[0].DISABILITY_CATEGORY_NM;
            let isAvailable = false;
            this.reviewData.disabilityCategory.forEach(element => {
              if (
                element.DISABILITY_CATEGORY_NM === data.DISABILITY_CATEGORY_NM
              ) {
                if (!element.DISABILITY_NAME) {
                  element.DISABILITY_NAME = [];
                }
                if (!otherExists) {
                  element.DISABILITY_NAME.push(this.diagId[i].OTHER_DS);
                } else {
                  element.DISABILITY_NAME.push(response.body[0].DISABILITY_DS);
                }
                isAvailable = true;
              }
            });
            if (!isAvailable) {
              if (!data.DISABILITY_NAME) {
                data.DISABILITY_NAME = [];
              }
              if (!otherExists) {
                data.DISABILITY_NAME.push(this.diagId[i].OTHER_DS);
              } else {
                data.DISABILITY_NAME = [response.body[0].DISABILITY_DS];
              }
              this.reviewData.disabilityCategory.push(data);
            }
          });
        }
      });
    }
    this.buildPlan();
  }

  builtAccoms() {
    Observable.forkJoin(
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getINCOMPLETE()
      ),
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getPENDING()
      )
    ).subscribe(([incStatus, pendStatus]) => {
      this.incStatusCd = incStatus[0].REQUEST_STATUS_CODE_ID;
      this.pendStatusCd = pendStatus[0].REQUEST_STATUS_CODE_ID;
    });

    for (let i = 0; i < this.reqAccoms.length; i++) {
      let otherExists = false;
      if (!this.reqAccoms[i].OTHER_DS) {
        otherExists = true;
      }
      this.autoApprovalRequestObj.accomsList.push(this.reqAccoms[i]);
      Observable.forkJoin(
        this.personRequestService.getAccomsName(
          this.reqAccoms[i].ACCOMMODATION_ID
        )
      ).subscribe(([response]) => {
        const data: any = {};
        if (response) {
          if (response.body[0].ACCOMMODATION_CD.includes("ELL")) {
            this.containsSupport = true;
          }
          Observable.forkJoin(
            this.personRequestService.getAccomsCategoryName(
              response.body[0].ACCOMMODATION_CATEGORY_ID
            )
          ).subscribe(([result]) => {
            data.ACCOMMODATION_CATEGORY_NM =
              result.body[0].ACCOMMODATION_CATEGORY_DS;
            let isAvailable = false;
            this.reviewData.displayAccomsList.forEach(element => {
              if (
                element.ACCOMMODATION_CATEGORY_NM ===
                data.ACCOMMODATION_CATEGORY_NM
              ) {
                if (!element.ACCOMMODATION_DS) {
                  element.ACCOMMODATION_DS = [];
                }
                if (!otherExists) {
                  if (this.reqAccoms[i].STATUS_CD === "P") {
                    element.ACCOMMODATION_DS.push(
                      "Previous Other:" + this.reqAccoms[i].OTHER_DS
                    );
                  } else {
                    element.ACCOMMODATION_DS.push(this.reqAccoms[i].OTHER_DS);
                  }
                } else {
                  element.ACCOMMODATION_DS.push(
                    response.body[0].ACCOMMODATION_DS
                  );
                }
                isAvailable = true;
              }
            });

            if (!isAvailable) {
              if (!data.ACCOMMODATION_DS) {
                data.ACCOMMODATION_DS = [];
              }
              if (!otherExists) {
                if (this.reqAccoms[i].STATUS_CD === "P") {
                  data.ACCOMMODATION_DS.push([
                    "Previous Other:" + this.reqAccoms[i].OTHER_DS
                  ]);
                } else {
                  data.ACCOMMODATION_DS.push([this.reqAccoms[i].OTHER_DS]);
                }
              } else {
                data.ACCOMMODATION_DS = [response.body[0].ACCOMMODATION_DS];
              }
              this.reviewData.displayAccomsList.push(data);
            }
          });
        }
      });
    }
    this.buildDocumentList();
  }

  buildDocumentList() {
    for (let i = 0; i < this.documentList.length; i++) {
      Observable.forkJoin(
        this.personRequestService.getDocumentTypeById(
          this.documentList[i].DOCUMENT_TYPE_ID
        )
      ).subscribe(([response]) => {
        const data: any = {};
        let isAvailable = false;
        this.autoApprovalRequestObj.documents.push(
          response.body[0].DOCUMENT_TYPE_NM
        );
        data.DOCUMENT_TYPE_DS = response.body[0].DOCUMENT_TYPE_DS;
        data.DISPLAY_ORDER_NO = response.body[0].DISPLAY_ORDER_NO;
        this.reviewData.documentDisplayList.forEach(element => {
          if (element.DOCUMENT_TYPE_DS === data.DOCUMENT_TYPE_DS) {
            if (!element.FileName) {
              element.FileName = [];
            }
            element.FileName.push(this.documentList[i].FILE_NM);
            isAvailable = true;
          }
        });
        if (!isAvailable) {
          if (!data.FileName) {
            data.FileName = [];
          }
          data.FileName = [this.documentList[i].FILE_NM];
          this.reviewData.documentDisplayList.push(data);
        }
        this.reviewData.documentDisplayList.sort((a, b) => {
          return a.DISPLAY_ORDER_NO - b.DISPLAY_ORDER_NO;
        });
      });
    }
    this.buildCommentList();
  }
  buildCommentList() {
    this.reviewData.commentList = this.commentList;
    this.isLoading = false;
  }

  buildTest() {
    Observable.forkJoin([
      this.testService.getTestNameByTestId(this.testId),
      this.testService.getTestDateName(this.testDateId),
      this.personRequestService.getRequestStatusCodeById(this.reqStatusCdId)
    ]).subscribe(([test, testDate, rss]) => {
      this.reviewData.testName = test[0].TEST_NM;
      this.reviewData.testDateName = testDate[0].TEST_DATE_NM;
      this.statusCd = rss[0].STATUS_CD;
      this.lockedFl = Number(rss[0].LOCKED_FL);

      if (this.lockedFl === 1) {
        // setupInReviewDetails(parameters);
        this.showEditButtons = false;
        this.showComments = false;
        this.showPrint = true;
        this.inReviewMsg = true;
      } else if (
        this.statusCd === this.taaConstants.getAPPROVED() ||
        this.statusCd === this.taaConstants.getNOT_APPROVED() ||
        this.statusCd === this.taaConstants.getPARTIALLY_APPROVED()
      ) {
        this.showEditButtons = true;
        this.showPrint = true;
        this.inReviewMsg = false;
        this.showComments = false;
      } else if (
        this.statusCd === this.taaConstants.getRECONSIDER_INCOMPLETE()
      ) {
        // submit request to have resonsider status. get rsc.reconsider
        this.auditStatusText =
          "Status Changed from ReconsiderIncomplete to Reconsider";
        this.auditLogCategory = "STATUS_CHANGE";
        this.auditLogComponent = "REQUEST_REVIEW_PAGE";
        Observable.forkJoin(
          this.requestSubmitService.getRequestStatusCodeIdByNm(
            this.taaConstants.getRECONSIDER()
          )
        ).subscribe(([submitStatus]) => {
          this.submitStatusCd = submitStatus[0].REQUEST_STATUS_CODE_ID;
        });

        this.showEditButtons = true;
        this.showCancelText = true;
        this.showTerms = true;
        this.showComments = true;
        this.inReviewMsg = false;
      } else if (this.statusCd === this.taaConstants.getINCOMPLETE()) {
        this.auditStatusText =
          "Status Changed from " + this.statusCd + " to Pending";
        this.auditLogCategory = "ASSIGN_TEST_ADMINISTRATION";
        this.auditLogComponent = "TAC_REQUEST_SUBMIT";
        // submit request to have Pending status. get rsc.pending
        Observable.forkJoin(
          this.requestSubmitService.getRequestStatusCodeIdByNm(
            this.taaConstants.getPENDING()
          )
        ).subscribe(([submitStatus]) => {
          this.submitStatusCd = submitStatus[0].REQUEST_STATUS_CODE_ID;
        });
        this.showEditButtons = true;
        this.showComments = false;
        this.showCancelText = true;
        this.showTerms = true;
        this.inReviewMsg = false;
      } else if (this.statusCd === this.taaConstants.getRECONSIDER()) {
        this.showComments = true;
        this.showTerms = false;
      }
    });
    this.buildDisability();
  }

  buildPlan() {
    for (let i = 0; i < this.personPlanId.length; i++) {
      Observable.forkJoin(
        this.planService.getPlanById(this.personPlanId[i].PLAN_ID)
      ).subscribe(([plan]) => {
        this.isPub = this.selectedOrg.publicCode === "Y" ? true : false;
        this.reviewData.isPub =
          this.selectedOrg.publicCode === "Y" ? true : false;
        if (plan[0].PLAN_NM !== "ELLPLAN") {
          this.disPlan = true;
          this.displayPlanName = true;
          this.reviewData.planName = plan[0].PLAN_NM;
          if (this.personPlanId[i].YEARS_ON_PLAN_NO === "=>4") {
            this.reviewData.lengthDisplay = "4 Months or More";
            this.autoApprovalRequestObj.planLength = "M";
          } else if (this.personPlanId[i].YEARS_ON_PLAN_NO === "<4") {
            this.reviewData.lengthDisplay = "Less Than 4 Months";
            this.autoApprovalRequestObj.planLength = "N";
          } else if (this.personPlanId[i].YEARS_ON_PLAN_NO === "=>1") {
            this.reviewData.lengthDisplay = "Twelve Calendar Months or More";
            this.autoApprovalRequestObj.planLength = "G";
          } else if (this.personPlanId[i].YEARS_ON_PLAN_NO === "<1") {
            this.reviewData.lengthDisplay = "Less Than Twelve Calendar Months";
            this.autoApprovalRequestObj.planLength = "L";
          } else {
            this.reviewData.lengthDisplay = "NA";
            this.autoApprovalRequestObj.planLength = "NA";
          }
        }
        if (plan[0].PLAN_NM === "ELLPLAN") {
          this.supReason = true;
          if (this.personPlanId[i].RECV_ELL_SUPP_IN_SCH === "Y") {
            this.containsSupport = true;
            // set display to Yes
            this.reviewData.supDisplay = "Yes";
          } else {
            // set display to No
            this.reviewData.supDisplay = "No";
          }
          this.autoApprovalRequestObj.planLength = "NA";
        }
      });
    }
    this.builtAccoms();
  }

  toggleEditable(event) {
    if (event.target.checked) {
      this.checkBox = true;
    } else {
      this.checkBox = false;
    }
  }
  getResult() {
    const personPlan = {
      PERSON_ID: this.personId,
      LOCKED_FL: "1",
      UPDATED_BY_DS: this.userProfile.loggedInUser
    };
    const personDisability = {
      PERSON_ID: this.personId,
      LOCKED_FL: "1",
      UPDATED_BY_DS: this.userProfile.loggedInUser
    };
    const personDocument = {
      PERSON_ID: this.personId,
      LOCKED_FL: "1",
      UPDATED_BY_DS: this.userProfile.loggedInUser
    };

    const updateRequest = {
      PERSON_ID: this.personId,
      TEST_DATE_ID: this.testDateId,
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      TEST_ID: this.testId,
      REQUEST_ID: this.requestId,
      REQUEST_STATE_TX: "7",
      REQUEST_STATUS_CODE_ID: this.submitStatusCd,
      SUBMITTED_BY_ID: this.selectedOrg.mdmId,
      SUBMITTED_BY_DS: this.userProfile.loggedInUser,
      SUBMITTED_BY_NM:
        this.userProfile.givenName + " " + this.userProfile.familyName,
      SUBMITTER_ROLE_CD: "ACCSUPPORT",
      CONSULTANT_ID: ""
    };

    return Observable.forkJoin(
      this.requestSubmitService.lockPersonPlan(personPlan),
      this.requestSubmitService.lockPersonDisability(personDisability),
      this.requestSubmitService.lockPersonDocument(personDocument),
      this.requestSubmitService.updateRequestForConfirm(updateRequest)
    );
  }

  submitData(navigate) {
    if (this.checkBox) {
      this.showCheckBoxError = false;
      if (
        this.autoApprovalRequestObj.documents.length > 0 &&
        this.autoApprovalRequestObj.disabilities.length > 0 &&
        this.autoApprovalRequestObj.planLength &&
        this.autoApprovalRequestObj.planLength !== null
      ) {
        this.showInvalidDataErr = false;
        this.subscriptions.push(
          this.getResult().subscribe(response => {
            if (response) {
              this.updateLogs();

              // Get status codes in order to move incomplete requested accommodations to pending.
              for (
                let i = 0;
                i < this.autoApprovalRequestObj.accomsList.length;
                i++
              ) {
                if (
                  this.autoApprovalRequestObj.accomsList[i]
                    .REQUEST_STATUS_CODE_ID === this.incStatusCd
                ) {
                  const updateRequestAccommodation = {
                    UPDATED_BY_DS: this.userProfile.loggedInUser,
                    REQUEST_ID: this.requestId,
                    REQUEST_STATUS_CODE_ID: this.pendStatusCd,
                    REQUESTED_ACCOMMODATION_ID: this.autoApprovalRequestObj
                      .accomsList[i].REQUESTED_ACCOMMODATION_ID
                  };
                  this.requestSubmitService
                    .updateRequestAccommodationStatus(
                      updateRequestAccommodation
                    )
                    .subscribe(accResponse => {});
                }
              }

              if (
                !(
                  this.reviewData.testDateName
                    .toLowerCase()
                    .includes("international") ||
                  this.reviewData.testDateName
                    .toLowerCase()
                    .includes("late consideration")
                ) &&
                (this.reqSupportFl !== "Y" ||
                  (this.reqSupportFl === "Y" &&
                    this.reviewData.supDisplay === "Yes" &&
                    this.selectedOrg.COUNTRY_CD === "US"))
              ) {
                Observable.forkJoin(this.checkRoutingRequest()).subscribe(
                  ([status]) => {
                    if (status[0]) {
                      this.autoApprovalRequestObj.accomsList = this.saveAccomsList;
                      this.updateRequestAfterRouting();
                    }
                  }
                );
              }

              this.commonService.setComfirmationPageData(this.reviewData);
              this.router.navigate(["reqConfirmation"]);
            }
          })
        );
      } else {
        this.showInvalidDataErr = true;
      }
    } else {
      this.showCheckBoxError = true;
    }
  }

  goToDocumentationPage() {
    this.stepper.goToPrevStep();
  }
  goToReasonPage() {
    this.stepper.goToStep(2);
  }
  goToPlanPage() {
    this.stepper.goToStep(3);
  }
  goToAccomsPage() {
    this.stepper.goToStep(4);
  }

  checkRoutingRequest() {
    this.autoApprovalRequestObj.personId = this.personId;
    this.autoApprovalRequestObj.requestId = this.requestId;
    this.saveAccomsList = this.autoApprovalRequestObj.accomsList;
    this.autoApprovalRequestObj.accomsList = this.autoApprovalRequestObj.accomsList.map(
      a => a.ACCOMMODATION_ID
    );
    return Observable.forkJoin(
      this.requestSubmitService.checkForRequestRouting(
        this.autoApprovalRequestObj
      )
    );
  }

  updateRequestAfterRouting() {
    Observable.forkJoin(
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getAP()
      ),
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getAPPROVED()
      ),
      this.requestSubmitService.getConsultantIdByNm(
        this.taaConstants.getSYSTEM_CONSULTANT()
      )
    ).subscribe(([submitStatus, appSubmitStatus, consult]) => {
      const updateReq = {
        PERSON_ID: this.personId,
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        REQUEST_ID: this.requestId,
        REQUEST_STATUS_CODE_ID: submitStatus[0].REQUEST_STATUS_CODE_ID,
        CONSULTANT_ID: consult[0].CONSULTANT_ID,
        USER_DATA_VAL:
          "Examinee " +
          this.reviewData.firstNm +
          " " +
          this.reviewData.lastNm +
          " is associated with test administration " +
          this.reviewData.testDateName
      };

      const updateRequestAccommodation = {
        PERSON_ID: this.personId,
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        REQUEST_ID: this.requestId,
        REQUEST_STATUS_CODE_ID: submitStatus[0].REQUEST_STATUS_CODE_ID,
        CONSULTANT_ID: consult[0].CONSULTANT_ID,
        CONTAINS_SUPPORT: this.containsSupport,
        CONTAINS_ACC: this.containsAcc,
        ACCOMMODATION_ID: "",
        REQUESTED_ACCOMMODATION_ID: ""
      };

      const reviewDetail = {
        REQUEST_ID: this.requestId,
        REQUEST_STATUS_CODE_ID: submitStatus[0].REQUEST_STATUS_CODE_ID,
        REVIEW_STEP_CD: this.taaConstants.getREVIEW_STEP_ONE(),
        STATUS_CD: this.taaConstants.getAP(),
        REVIEW_TYPE_CD: "PAPER",
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        CREATED_BY_DS: this.userProfile.loggedInUser,
        CONSULTANT_ID: consult[0].CONSULTANT_ID
      };

      const reviewDetailAccStatus = {
        REQUEST_ID: this.requestId,
        REQUEST_STATUS_CODE_ID: appSubmitStatus[0].REQUEST_STATUS_CODE_ID,
        REVIEW_DETAIL_ID: "",
        REQUESTED_ACCOMMODATION_ID: "",
        ACCOMMODATION_ID: "",
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        CREATED_BY_DS: this.userProfile.loggedInUser
      };

      for (let v = 0; v < this.autoApprovalRequestObj.accomsList.length; v++) {
        updateRequestAccommodation.REQUESTED_ACCOMMODATION_ID = this.autoApprovalRequestObj.accomsList[
          v
        ].REQUESTED_ACCOMMODATION_ID;
        updateRequestAccommodation.ACCOMMODATION_ID = this.autoApprovalRequestObj.accomsList[
          v
        ].ACCOMMODATION_ID;
        Observable.forkJoin(
          this.requestSubmitService.updateRequestAccommodationForRoute(
            updateRequestAccommodation
          )
        ).subscribe(
          ([updatedReqAccomm]) => {},
          error => {
            console.log(error);
          }
        );
      }

      Observable.forkJoin(
        this.requestSubmitService.updateRequestForRouting(updateReq),
        this.requestSubmitService.updateRequestAccommodationForRoute(
          updateRequestAccommodation
        ),
        this.requestSubmitService.postReviewDetail(reviewDetail)
      ).subscribe(
        ([upRe, inRd]) => {
          const inrdTemp: any = inRd;
          reviewDetailAccStatus.REVIEW_DETAIL_ID =
            inrdTemp.body.REVIEW_DETAIL_ID;
          for (
            let i = 0;
            i < this.autoApprovalRequestObj.accomsList.length;
            i++
          ) {
            setTimeout(
              count => {
                reviewDetailAccStatus.REQUESTED_ACCOMMODATION_ID = this.autoApprovalRequestObj.accomsList[
                  count
                ].REQUESTED_ACCOMMODATION_ID;
                reviewDetailAccStatus.ACCOMMODATION_ID = this.autoApprovalRequestObj.accomsList[
                  count
                ].ACCOMMODATION_ID;
                Observable.forkJoin(
                  this.requestSubmitService.postReviewDetailAccommStatus(
                    reviewDetailAccStatus
                  )
                ).subscribe(
                  ([rDAS]) => {
                    if (rDAS) {
                      console.log("Adding rdas.");
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              },
              true,
              i
            );
          }
        },
        err => {
          console.log(err);
        }
      );
    });
  }
  regexTest(str, length) {
    if (_.isEmpty(_.toString(str))) {
      return false;
    }
    if (str.length > length) {
      return false;
    }
    const pattern = /^[a-zA-Z0-9\.\s\,\:\;]{1,500}$/;
    const regex = new RegExp(pattern);
    return regex.test(str);
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/paperreqsubmit/paperreqsubmit.component.ts